import cn from 'classnames';
import React, { useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import MenuItems from 'components/layouts/Header/MenuItems';

import { useAppSelector } from 'redux-store';

import s from './DesktopMenu.module.scss';

function getInitials(username: string): string {
  const words = username.trim().split(' ');

  if (words.length > 1) {
    return words.reduce(
      (previousValue, currentValue) => previousValue[0] + currentValue[0],
    );
  } else {
    return words[0][0];
  }
}

export default function DesktopMenu(): JSX.Element | null {
  const profile = useAppSelector(state => {
    return state.profile;
  });
  const [isMenuOpen, setMenuOpen] = useState(false);
  const closed = useDebouncedCallback(() => {
    setMenuOpen(false);
  }, 300);

  if (!profile.isAuthenticated) {
    return null;
  }

  const {
    profile: { username, email },
  } = profile;
  const initials = getInitials(username);

  return (
    <div className={cn(s.menuWrapper, s.desktopMenu)}>
      <div
        className={cn(s.wrapper, 'cy-desktop-profile-menu')}
        onMouseEnter={(): void => {
          closed.cancel();
          setMenuOpen(true);
        }}
        onMouseLeave={closed}
      >
        <div className={s.initialsWrapper}>{initials}</div>
        <div>
          <div className={s.username}>{username}</div>
          <div className={s.email}>{email}</div>
        </div>
      </div>

      <div
        className={cn(s.menu, {
          [s.open]: isMenuOpen,
        })}
        onMouseEnter={(): void => {
          closed.cancel();
          setMenuOpen(true);
        }}
        onMouseLeave={closed}
      >
        <MenuItems />
      </div>
    </div>
  );
}
